export default __webpack_public_path__ + "static/media/step_school.c24a90d7.png";